/**
 * <igf-countdown target="2026-11-08T00:00:00"> — ticks down to a date.
 * Vanilla custom element, no dependencies. Stops itself at zero and when
 * the tab is hidden so it does not burn a timer in the background.
 */
class IgfCountdown extends HTMLElement {
  connectedCallback() {
    this.fields = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    const target = Date.parse(this.getAttribute('target'));
    this.target = Number.isNaN(target) ? null : target;

    if (this.target === null) return;

    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibility);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  start() {
    this.tick();
    if (!this.timer) this.timer = setInterval(() => this.tick(), 1000);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  tick() {
    const remaining = Math.max(0, this.target - Date.now());

    const seconds = Math.floor(remaining / 1000);
    this.render('days', Math.floor(seconds / 86400));
    this.render('hours', Math.floor(seconds / 3600) % 24);
    this.render('minutes', Math.floor(seconds / 60) % 60);
    this.render('seconds', seconds % 60);

    if (remaining === 0) this.stop();
  }

  render(unit, value) {
    const field = this.fields[unit];
    if (!field) return;

    const text = unit === 'days' ? String(value) : String(value).padStart(2, '0');
    if (field.textContent !== text) field.textContent = text;
  }
}

customElements.define('igf-countdown', IgfCountdown);

/**
 * Mobile navigation drawer. Toggles an attribute on the nav so all the
 * open-state styling stays in CSS.
 */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-igf-menu-toggle]');
  const overlay = event.target.closest('.igf-nav__overlay');
  if (!toggle && !overlay) return;

  const nav = (toggle || overlay).closest('.igf-header').querySelector('.igf-nav');
  const open = nav.hasAttribute('open-menu');

  nav.toggleAttribute('open-menu', !open);
  document.documentElement.classList.toggle('igf-menu-open', !open);
  if (toggle) toggle.setAttribute('aria-expanded', String(!open));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.igf-nav[open-menu]').forEach((nav) => {
    nav.removeAttribute('open-menu');
    document.documentElement.classList.remove('igf-menu-open');
    nav
      .closest('.igf-header')
      .querySelector('[data-igf-menu-toggle]')
      ?.setAttribute('aria-expanded', 'false');
  });
});
